import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLightningBolt = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 40 41",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M21 11.364L11 22.364H20L19 29.364L29 18.364H20L21 11.364Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeMiterlimit: 10,
		strokeLinecap: "square"
	})
});
const ForwardRef = forwardRef(SvgLightningBolt);
export default ForwardRef;
